import type { TranslationFunctions } from '$i18n/i18n-types';
import { Tier } from './calculation';

/**
 * @param rankTierName getRankTier().tier.tierName 사용
 * @param queueType
 */
export function getRankTierCircleIconUrl(rankTierName: string) {
  return `/images/ranks/Circle_${rankTierName}.webp`;
}

export function getRankTierTransparentIconUrl(rankTierName: string) {
  if (rankTierName === 'None') {
    rankTierName = 'Iron';
  }
  return `/images/ranks/Transparent_${rankTierName}.webp`;
}

export function getRankTierColorName(rankTierName: string) {
  return rankTierName === Tier[Tier.None] ? 'unranked' : rankTierName.toLowerCase();
}

export function getTranslatedRankTierName(LL: TranslationFunctions, rankTierName: string) {
  return LL.glossary.tiers[
    getRankTierColorName(rankTierName) as keyof TranslationFunctions['glossary']['tiers']
  ]();
}

export function getShortRankTierName(LL: TranslationFunctions, rankTierName: string) {
  return LL.glossary.tiersShort[
    getRankTierColorName(rankTierName) as keyof TranslationFunctions['glossary']['tiersShort']
  ]();
}
